import { useNavigation } from '@react-navigation/native';
import ParkingContext from 'context/ParkingContext';
import { useContext } from 'react';
import { View, ViewProps } from 'react-native';
import { useParkingStore } from 'stores/parkingStore';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import { RootNavProps } from 'types/navigation';
import PrepaidTicketOrPermitItem from '../detail/PrepaidTicketOrPermitItem';

const PermitInfoBox: React.FC<ViewProps> = ({ ...props }) => {
  const { navigate } = useNavigation<RootNavProps>();
  const { setSelectedParkzonePmcUnion, salesOrdersForZoneAndVehicle } =
    useContext(ParkingContext);

  const { parkingZoneCountryCode } = useParkingStore(
    (state) => state.parkingConditions
  );

  const onPurchasedPermitSelect = (permit: UnifiedPermit) => {
    setSelectedParkzonePmcUnion(permit);
    navigate('salesOrderPermitEdit', {
      orderLineIdWithVersion: permit.orderLineIdWithVersion || '',
    });
  };

  return (
    <View {...props}>
      {salesOrdersForZoneAndVehicle?.map((item, index) => (
        <ColumnWithMargins
          key={`prepaid-owned-permit-${item.id}`}
          mt={0}
          mb={8}>
          <PrepaidTicketOrPermitItem
            testID={`prepaid-owned-ticket-${index}`}
            item={item as UnifiedPermit}
            countryCode={parkingZoneCountryCode || 'FI'}
            onPress={onPurchasedPermitSelect}
          />
        </ColumnWithMargins>
      ))}
    </View>
  );
};

export default PermitInfoBox;
